import { render, staticRenderFns } from "./delivery-signature-content.vue?vue&type=template&id=ff5e2b34&scoped=true"
import script from "./delivery-signature-content.vue?vue&type=script&lang=js"
export * from "./delivery-signature-content.vue?vue&type=script&lang=js"
import style0 from "./delivery-signature-content.vue?vue&type=style&index=0&id=ff5e2b34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5e2b34",
  null
  
)

export default component.exports